import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ModeToggle } from "@/components/theme-toggle";

interface HeaderProps {
  onSearch?: (query: string) => void;
  searchValue?: string;
}

export function Header({ onSearch, searchValue = "" }: HeaderProps) {
  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex items-center justify-between gap-6">
          <Link to="/" className="flex-shrink-0">
            <h1 className="text-2xl md:text-3xl font-black bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
              StreamFree
            </h1>
          </Link>

          {onSearch && (
            <div className="flex-1 max-w-md hidden sm:block">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  placeholder="Search movies..."
                  className="pl-10"
                  onChange={(e) => onSearch(e.target.value)}
                  value={searchValue}
                />
              </div>
            </div>
          )}

          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}